import React from 'react';
import { Button, Dialog, Stack, Typography } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  AccessTimeRounded as AccessTimeRoundedIcon,
  EventRounded as EventRoundedIcon
} from '@mui/icons-material';
import { classes } from './styles';
import { sharedClasses } from '../NewUI/Components/CustomUIElements/sharedClasses';
import DateDisplay from './CreateEvent/EventProgress/DateDisplay';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
import { ScoutCalendarState } from './types';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

export default function EventCreated({
  open,
  onClose,
  ScoutCalendarState,
  userTimezone
}: {
  open: boolean;
  onClose: () => void;
  ScoutCalendarState: ScoutCalendarState;
  userTimezone: string;
}) {
  const { createEventObject } = ScoutCalendarState;
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const sessions = Array.from({ length: Number(createEventObject.sessions) }, (_, i) =>
    dayjs(createEventObject.eventDate)
      .tz(userTimezone || browserTimezone)
      .add(i * (Number(createEventObject.duration) + Number(createEventObject.breaks)), 'm')
      .toDate()
  );
  return (
    <Dialog open={open} onClose={onClose} data-testid="event-created-modal">
      <Stack sx={classes.eventCreatedModalContainer}>
        <CheckCircleIcon sx={{ color: '#5BC4BF', fontSize: '4rem', marginTop: 4 }} />
        <Typography sx={classes.eventCreatedModalTitle}>Event Created</Typography>
        <Stack sx={{ alignItems: 'center', rowGap: 1, color: '#333333' }}>
          <Typography sx={{ fontWeight: 'bold', wordBreak: 'break-word' }}>
            {createEventObject.eventName}
          </Typography>
          <Stack sx={{ flexDirection: 'row' }} gap={1}>
            <EventRoundedIcon
              sx={{ color: '#666', width: '16px', marginRight: '1', columnGap: 'unset' }}
            />
            <DateDisplay dates={createEventObject.dates} />
          </Stack>
          <Stack sx={{ flexDirection: 'row' }} gap={1}>
            <AccessTimeRoundedIcon sx={{ color: '#666', width: '16px' }} />
            <Stack sx={classes.eventSessionsContainer}>
              {sessions.map((session, index) => (
                <Typography sx={{ textDecoration: 'underline' }} key={index}>
                  {dayjs(session)
                    .tz(userTimezone || browserTimezone)
                    .format('h:mm a')}{' '}
                  -{' '}
                  {dayjs(session)
                    .tz(userTimezone || browserTimezone)
                    .add(Number(createEventObject.duration), 'm')
                    .format('h:mm a')}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Stack>
        <Button
          variant="contained"
          sx={{ ...sharedClasses.genericButton, margin: '16px 0px' }}
          onClick={onClose}
          data-testid="event-created-modal-exit-button"
        >
          Exit
        </Button>
      </Stack>
    </Dialog>
  );
}
